import { deleteApi, get, post } from "../GenericServices";

const WbsCategory = {
  getWbsCategoriesList: (queryString) => {
    return get(`wbs-category?${queryString}`);
  },
  wbsCategoryData: (id) => {
    return get(`wbs-category/${id}`);
  },
  saveWbsCategory: (data) => {
    return post("wbs-category", data);
  },
  deleteWbsCategory: (id) => {
    return deleteApi(`wbs-category/${id}`);
  },
};

export default WbsCategory;
